<template>
    <div class="flex flex-col gap-6">
        <div class="relative md:hidden">
            <MiscSkeleton size="large" />
        </div>

        <div class="flex flex-col md:flex-row md:gap-8">
            <div class="hidden md:flex md:flex-col md:gap-3 md:w-56 md:shrink-0">
                <MiscSkeleton size="medium" width="120px" />
                <div class="flex flex-col gap-2">
                    <MiscSkeleton size="small" :repeat="10" />
                </div>
            </div>

            <div class="flex-1 min-w-0 flex flex-col gap-6">
                <div class="relative">
                    <div class="flex flex-col gap-3 w-full mb-4 md:gap-2 md:max-w-2xl md:min-h-[60px] md:mb-3">
                        <MiscSkeleton size="large" :repeat="1" />
                    </div>
                    <div class="flex gap-2 justify-between w-full border-b pb-4 md:border-b-0 md:pt-3 md:border-t">
                        <div class="w-full md:absolute md:top-0 md:right-0 md:w-auto">
                            <MiscSkeleton size="large" width="160px" :repeat="1" />
                        </div>
                        <div class="w-full md:hidden">
                            <MiscSkeleton size="large" width="160px" :repeat="1" />
                        </div>
                        <div class="hidden md:block">
                            <div class="w-full relative md:inline-flex md:items-start md:gap-2 md:w-max md:flex-nowrap">
                                <MiscSkeleton size="medium" width="124px" :repeat="6" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-6">
                    <MiscSkeleton :repeat="8" :height="450" />
                </div>
            </div>
        </div>
    </div>
</template>
